import { Box, Switch, Table, TableBody, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import TaskCard from "./TaskCard";
import moment from "moment";
import B2BTaskCard from "./B2BTaskCard";
import { axiosInstance } from "../../../utils/networking";
import React from "react";

const decodeTimeLine = (timeline: any) => {
  if (timeline === "On going") {
    return "On going";
  } else {
    return parseInt(timeline.split(" ")[0]); // e.g. "30 days" -> 30
  }
};

const orderActionsByDate = (actions: any[]) => {
  actions.forEach((action) => {
    if (action["case"]["_id"] === "660357e0f718a1570f1b08ff") {
      console.log("action before", JSON.parse(JSON.stringify(action)));
    }
    if (action["timeLine"] === "On going") {
      action["daysLeft"] = 9999;
    } else {
      action["startDateObj"] = moment(
        action["startDate"] ? action["startDate"] : "1970-01-01",
      );
      action["timeLineDays"] = decodeTimeLine(action["timeLine"]);
      action["endDate"] = action["startDateObj"]
        .clone()
        .add(action["timeLineDays"], "days");
      action["daysLeft"] = action["endDate"].diff(moment(), "days");
    }
    if (action["case"]["_id"] === "660357e0f718a1570f1b08ff") {
      console.log("action days left", action);
    }
  });
  return actions.sort((a, b) => a.daysLeft - b.daysLeft);
};

const Tasks = (props: any) => {
  const [originalActions, setOriginalActions] = useState<any>(null); // [action1, action2, ...
  const [actions, setActions] = useState<any>(null);
  const [b2bCheck, setB2bCheck] = useState<boolean>(false);

  useEffect(() => {
    const fetchActionData = async () => {
      let res = await axiosInstance.get(`/actionPlan/get_all`);
      const rawActions =
        res.data.action_plans || res.data.actionPlans || res.data;
      const rawActionsArray = Array.isArray(rawActions) ? rawActions : [];
      // console.log("raw actions", res.data.action_plans);
      const orderedActions = orderActionsByDate(
        JSON.parse(JSON.stringify(rawActionsArray)),
      );
      // console.log("sorted actions", orderedActions);
      setOriginalActions(orderedActions);
      setActions(orderedActions);
    };
    fetchActionData();
  }, []);

  // useEffect(() => {
  //   if (originalActions) {
  //     const filteredActions = originalActions.filter((action: any) => {
  //       return action.content.action === "B2B Referral";
  //     });
  //     setActions(filteredActions);
  //   }
  // }, [originalActions]);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setB2bCheck(event.target.checked);
    if (event.target.checked) {
      // console.log("switch to B2B");
      setActions(
        originalActions.filter((action: any) => {
          return action.action === "B2B Referral";
        }),
      );
    } else {
      setActions(originalActions);
    }
  };

  return actions ? (
    <>
      <Box
        sx={{
          width: "100%",
          height: "840px",
          backgroundColor: "#e7e7e747",
          borderRadius: "15px",
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            backgroundColor:
              process.env.REACT_APP_API_DOMAIN !=
              "https://www.thrive-drive.org:8443"
                ? "rgb(63, 93, 125)"
                : "rgb(158, 31, 99)",
            padding: "3px",
            margin: 0,
            color: "white",
            borderRadius: "15px 15px 0 0",
          }}
        >
          <Typography sx={{ display: "inline-block" }} variant="h6">
            {b2bCheck ? "B2B Plan Calendar" : "Action Plan Calendar"}
          </Typography>
          <Switch
            checked={b2bCheck}
            color="warning"
            sx={{ float: "right" }}
            onChange={handleSwitchChange}
          ></Switch>
        </Box>

        <Box sx={{ overflowY: "auto", height: "92%", width: "100%" }}>
          {actions.map((action: any, index: number) => {
            if (!action.status || action.status !== "completed") {
              if (action.action === "B2B Referral") {
                return (
                  action.case && (
                    <B2BTaskCard
                      firm={action.firm}
                      key={index}
                      action={action}
                      case_id={action.case._id}
                    ></B2BTaskCard>
                  )
                );
              } else {
                return (
                  action.case && (
                    <TaskCard
                      firm={action.firm}
                      key={index}
                      action={action}
                      case_id={action.case._id}
                    ></TaskCard>
                  )
                );
              }
            }
            return null;
          })}
        </Box>
      </Box>
    </>
  ) : (
    <>No Action Plan</>
  );
};

export default React.memo(Tasks);
